import { useEffect, useRef } from 'react';
export function useScrollIntersection({ onIntersect, register = true, threshold = 0, }) {
    const targetRef = useRef(null);
    const parentRef = useRef(null);
    useEffect(function registerIntersectionObserver() {
        if (!targetRef.current || !register)
            return;
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                onIntersect();
            }
        }, {
            root: parentRef.current,
            threshold,
        });
        observer.observe(targetRef.current);
        return function cleanup() {
            observer.disconnect();
        };
    }, [targetRef, parentRef, onIntersect, threshold, register]);
    return { targetRef, parentRef };
}
//# sourceMappingURL=useScrollIntersection.js.map